import {
	Component,
	OnInit,
	Input,
	Output,
	EventEmitter,
	ViewChild,
} from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { tap } from 'rxjs/operators';

import { EventsService } from '../../core/services/events-service/events.service';

import { AlertComponent } from '../../shared';

@Component({
	selector: 'eze-pay-by-upload-modal',
	templateUrl: './pay-by-upload-modal.component.html',
	styleUrls: ['./pay-by-upload-modal.component.css'],
})
export class PayByUploadModalComponent implements OnInit {
	form: FormGroup;
	showValidation = false;
	submitting = false;

	@ViewChild('modal', { static: false })
	modal;

	@ViewChild(AlertComponent, { static: false })
	alert: AlertComponent;

	@Input()
	eventId: any;

	@Input()
	payload: any;

	@Input()
	entity: string;

	@Output()
	success = new EventEmitter();

	@Input()
	title;

	@Input()
	instructions;

	@Input()
	bypassDocument;

	opened = false;

	constructor(
		private fb: FormBuilder,
		private eventsService: EventsService
	) {}

	ngOnInit() {
		this.form = this.fb.group({
			document_id: ['', !this.bypassDocument && Validators.required],
		});
	}

	preparePayload() {
		return {
			...this.payload,
			processor: 'pay_by_upload',
			document_id: this.form.get('document_id').value,
		};
	}

	onSubmit() {
		if (this.submitting) {
			return;
		}

		if (this.form.invalid) {
			this.alert.newAlert('Please fill out required fields', 'danger');
			this.showValidation = true;
			return;
		}

		this.alert.newAlert('Submitting...', 'info');
		this.submitting = true;
		this.eventsService
			.postEntity(this.eventId, this.entity, this.preparePayload())
			.pipe(
				tap(
					() => (this.submitting = false),
					() => (this.submitting = false)
				)
			)
			.subscribe(
				(res: any) => {
					this.success.next(res._html_message);

					// close and reset
					this.modal.close();
					this.form.reset();
					this.alert.closeAlert();
					this.opened = false;
				},
				(err) => {
					this.alert.newAlert(
						(err && err.error && err.error.message) ||
							'There was an error in submitting your payment.',
						'danger'
					);
				}
			);
	}

	onModalOpen() {
		this.form.enable();
		this.alert.closeAlert();
	}

	open() {
		this.modal.open();
		this.opened = true;
	}
}
